import { Item } from '../../models/item';
import { Manufacturer, MANUFACTURER_OPTIONS, UNKNOWN_MANUFACTURER } from '../types';

export function groupItemsByManufacturer(orderItems: Item[]) {
  // include manufacturer into order item data
  const items = orderItems.map(item => {
    return {
      ...item,
      manufacturer: isValidManufacturer(item.product.vendor)
        ? item.product.vendor.toLowerCase()
        : UNKNOWN_MANUFACTURER,
    };
  });

  const manufacturers = items
    .map(i => i.manufacturer)
    .filter((m, i, arr) => !!m && arr.indexOf(m) === i);

  const grouped: Record<Manufacturer, Item[]> = {} as any;
  manufacturers.forEach((man: Manufacturer) => {
    grouped[man] = items.filter(item => item.manufacturer === man);
  });
  return grouped;
}

export function isValidManufacturer(man: string): man is Manufacturer {
  return man && MANUFACTURER_OPTIONS.indexOf(man.toLowerCase() as Manufacturer) > -1;
}
